import { render } from "./addPlatform.vue?vue&type=template&id=1fb4bf97&scoped=true"
import script from "./addPlatform.vue?vue&type=script&lang=js"
export * from "./addPlatform.vue?vue&type=script&lang=js"

import "./addPlatform.vue?vue&type=style&index=0&id=1fb4bf97&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb4bf97"]])

export default __exports__